import clsx from 'clsx';
import Icon from '../Icon';

type IconClearProps = {
  className?: string;
  onClick?: () => void;
};

const IconClear: React.FC<IconClearProps> = ({ className, onClick }) => {
  return (
    <Icon
      icon="clear"
      onClick={onClick}
      className={clsx(
        className,
        'text-small cursor-pointer opacity-80 hover:opacity-100'
      )}
    />
  );
};

export default IconClear;
